import React from "react";
import ProposalFloorPlan from "./proposal-floor-plan";
import ProposalComparisonTable from "./proposal-comparison-table";
import { FurnishingDetailsViewOption } from "../../create-proposal/components/props";
const publicUrl = window.location.origin; // process.env.PUBLIC_URL;
const logoIcon = `${publicUrl}/city-info-logo-pdf.png`;
const proposalTableShadow = `${publicUrl}/proposal-table-shadow.jpg`;
const backgroundBgWithShadow = `${publicUrl}/background-bg-with-shadow.jpg`;

type RenderFloorPlanAndFurnishingDetailsProps = {
  properties: any;
  index: number;
  showFurnishingDetails: boolean;
};

const RenderFloorPlanAndFurnishingDetails: React.FC<RenderFloorPlanAndFurnishingDetailsProps> = ({
  properties,
  index,
  showFurnishingDetails,
}) => {
  const isThreeColumn = properties.some(
    (proprty: any) =>
      proprty.furnishingDetailsViewOption ===
      FurnishingDetailsViewOption.ThreeColumn
  );
  if (isThreeColumn) {
    return (
      <>
        {properties.map((propertyDetails: any) => {
          return (
            <>
              {/* floor plan only start  */}
                <ProposalFloorPlan
                  index={index}
                  propertyDetails={propertyDetails}
                />
              {/* floor plan only end */}
            </>
          );
        })}

        {/* comparison start  */}
        {properties.some((item:any)=>item?.furnishingDetails?.length) &&<table
          className="table-outer-area page-break"
          style={{
            // backgroundImage: `url(${require("../../../assets/images/proposal/common-table-bg.png")})`,
            // backgroundImage: `url(${commonTableBg})`,
            backgroundImage: `url(${proposalTableShadow})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "bottom",
            backgroundSize: "cover",
            marginTop: "15px",
          }}
          width="100%"
          cellPadding="10"
          cellSpacing="0"
        >
          <tbody>
            <tr>
              <td align="right">
                <img width={110} src={logoIcon} alt="property image" />
              </td>
            </tr>

            <tr>
              <td
                width="100%"
                className="pl-40"
                style={{
                  color: "#021D77",
                  marginTop: "-57px",
                  display: "block",
                }}
              >
                <span style={{ fontSize: "18px" }}>
                  O P T I O N {index + 1}
                </span>
                <br />
                <div style={{ display: "flex" }}>
                  <strong
                    style={{
                      fontSize: "25px",
                      fontWeight: 700,
                      maxWidth: "80%",
                      flexShrink: 0,
                    }}
                  >
                    {properties[0]?.propertyName?.toUpperCase()}
                  </strong>
                  <div
                    style={{
                      height: "4px",
                      width: "100%",
                      backgroundColor: "#C39864",
                      marginTop: "18px",
                      marginLeft: "10px",
                    }}
                  ></div>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <table cellPadding="10" cellSpacing="0" width="100%">
                  <tbody>
                    {/* <tr>
                      <td height="42"></td>
                    </tr> */}
                    <tr>
                      <td align="center">
                        <table
                          // cellPadding="22"
                          // cellSpacing="25"
                          width="100%"
                          style={{ borderCollapse: "separate" }}
                        >
                          <tbody>
                            <tr>
                              <td>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    flexWrap: "wrap",
                                    gap: "20px",
                                  }}
                                >
                                  {properties.map(
                                    (
                                      pprtyDetails: any,
                                      indexNumber: number
                                    ) => (
                                      pprtyDetails?.furnishingDetails?.length &&
                                       <ProposalComparisonTable
                                        indexNumber={indexNumber}
                                        pprtyDetails={pprtyDetails}
                                        properties={properties}
                                      />
                                    )
                                  )}
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>

            <tr>
              <td style={{ backgroundColor: "#021D77" }} height="50"></td>
            </tr>
          </tbody>
        </table>}
        {/* comparison end */}
      </>
    );
  } else {
    return properties.map((propertyDetails: any) => {
      if (
        propertyDetails?.furnishingDetailsViewOption ===
        FurnishingDetailsViewOption.SinglePage
      ) {

        const furnishingDetails = [
          ...(propertyDetails.furnishingDetails ||
            []),
          ...(propertyDetails.otherFurnishingDetails ||
            []),
        ]
        return (
          <>
            {/* floor plan only start  */}
            <ProposalFloorPlan
              index={index} 
              propertyDetails={propertyDetails}
            />
            {/* floor plan only end */}

            {/* furnishing detials only start  */}
            {showFurnishingDetails ? (
              <table
                className="table-outer-area page-break"
                style={{
                  // backgroundImage: `url(${require("../../../assets/images/proposal/common-table-bg.png")})`,
                  // backgroundImage: `url(${commonTableBg})`,
                  backgroundImage: `url(${proposalTableShadow})`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "bottom",
                  backgroundSize: "cover",
                  marginTop: "15px",
                  minHeight: "794px",
                }}
                width="100%"
                cellPadding="10"
                cellSpacing="0"
              >
                <tbody>
                  <tr>
                    <td align="right">
                      <img width={110} src={logoIcon} alt="property image" />
                    </td>
                  </tr>

                  <tr>
                    <td
                      width="100%"
                      className="pl-40"
                      style={{
                        color: "#021D77",
                        marginTop: "-57px",
                        display: "block",
                      }}
                    >
                      <span style={{ fontSize: "18px" }}>
                        O P T I O N {index + 1}
                      </span>
                      <br />
                      <div style={{ display: "flex" }}>
                        <strong
                          style={{
                            fontSize: "25px",
                            fontWeight: 700,
                            maxWidth: "80%",
                            flexShrink: 0,
                          }}
                        >
                          {propertyDetails?.propertyName?.toUpperCase()}
                        </strong>
                        <div
                          style={{
                            height: "4px",
                            width: "100%",
                            backgroundColor: "#C39864",
                            marginTop: "18px",
                            marginLeft: "10px",
                          }}
                        ></div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <table cellPadding="0" cellSpacing="0" width="100%">
                        <tbody>
                          <tr>
                            <td height="50"></td>
                          </tr>

                          <tr>
                            <td align="center">
                              {!!furnishingDetails.length && <table
                                cellPadding="0"
                                cellSpacing="0"
                                width="500"
                              >
                                <tbody>
                                  <tr>
                                    <td>
                                      <span
                                        style={{
                                          fontSize: "20px",
                                          color: "#8FA9D4",
                                          fontWeight: 700,
                                        }}
                                      >
                                        <u>FURNISHING DETAILS</u>
                                      </span>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td height="12"></td>
                                  </tr>
                                  <tr>
                                    <td
                                      style={{
                                        padding: "20px",
                                        borderRadius: "12px",
                                        // background: `url(${require("../../../assets/images/proposal/box-shadow.png")})`,
                                        // backgroundPosition: "bottom 0 center",
                                        // backgroundSize: "200%",
                                        backgroundColor: "#F8F5FA",
                                        boxShadow:
                                          "0 3px 5px 0 rgba(0, 0, 0, 0.2), 0 10px 20px 0 rgba(0, 0, 0, 0.19)",
                                      }}
                                    >
                                      <table
                                        width="100%"
                                        cellPadding="0"
                                        cellSpacing="0"
                                      >
                                        <tbody>
                                          <tr>
                                            <td valign="top">
                                              <ul
                                                style={{
                                                  listStyleType: "none",
                                                  padding: "0",
                                                  marginBottom: "0",
                                                  columnCount: 2,
                                                }}
                                              >
                                                {furnishingDetails.map(
                                                  (floor: {
                                                    name?: string;
                                                    value?: string;
                                                    attrName: number;
                                                    attrOptionValue: number;
                                                  }) => (
                                                    <li
                                                      // className="col-md-6"
                                                      style={{
                                                        color: "#5E5E5E",
                                                        fontSize: "14px",
                                                        marginBottom: "5px",
                                                        lineHeight: "25px",
                                                      }}
                                                    >
                                                      <u
                                                        style={{
                                                          color: "#00134F",
                                                        }}
                                                      >
                                                        {floor?.attrName ||
                                                          floor?.name}
                                                        :{" "}
                                                      </u>
                                                      {floor?.attrOptionValue ||
                                                        floor?.value}
                                                    </li>
                                                  )
                                                )}
                                              </ul>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td height="65"></td>
                  </tr>
                  <tr>
                    <td
                      style={{ backgroundColor: "#021D77" }}
                      height="50"
                      align="center"
                    ></td>
                  </tr>
                </tbody>
              </table>
            ) : (
              ""
            )}
            {/* furnishing detials only end */}
          </>
        );
      } else if (
        propertyDetails?.furnishingDetailsViewOption ===
        FurnishingDetailsViewOption.TwoColumn
      ) {

        const furnishingDetails = [
          ...(propertyDetails.furnishingDetails ||
            []),
          ...(propertyDetails.otherFurnishingDetails ||
            []),
        ]

        const hidePropertyFloorImage: boolean = propertyDetails.excludeFloorPlan ||
        !propertyDetails?.propertyFloorImage
        return (
          <>
            {/* floor plan and furnishing details (left | right ) start   */}
            {(!showFurnishingDetails || !furnishingDetails.length) && hidePropertyFloorImage ? null : (
              <table
                className="table-outer-area page-break"
                style={{
                  // backgroundImage: `url(${require("../../../assets/images/proposal/background-bg-with-shadow.png")})`,
                  backgroundImage: `url(${backgroundBgWithShadow})`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "bottom",
                  backgroundSize: "cover",
                  marginTop: "15px",
                  minHeight: "794px",
                }}
                width="100%"
                cellPadding="10"
                cellSpacing="0"
              >
                <tbody>
                  <tr>
                    <td align="right" height="90">
                      <img width={110} src={logoIcon} alt="property image" />
                    </td>
                  </tr>
                  {/* <tr>
                    <td align="right">
                      <table width="40%" cellPadding="10" cellSpacing="0">
                        <tbody>
                          <td
                            height="4"
                            style={{ backgroundColor: "#C39864", padding: "0" }}
                          ></td>
                        </tbody>
                      </table>
                    </td>
                   </tr> */}
                  <tr>
                    <td
                      width="100%"
                      className="pl-40"
                      style={{
                        color: "#021D77",
                        marginTop: "-38px",
                        display: "block",
                      }}
                    >
                      <span style={{ fontSize: "18px" }}>
                        O P T I O N {index + 1}
                      </span>
                      <br />
                      <div style={{ display: "flex" }}>
                        <strong
                          style={{
                            fontSize: "25px",
                            fontWeight: 700,
                            maxWidth: "80%",
                            flexShrink: 0,
                          }}
                        >
                          {propertyDetails?.propertyName?.toUpperCase()}
                        </strong>
                        <div
                          style={{
                            height: "4px",
                            width: "100%",
                            backgroundColor: "#C39864",
                            marginTop: "18px",
                            marginLeft: "10px",
                          }}
                        ></div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td height="20"></td>
                  </tr>
                  <tr>
                    <td valign="top">
                      <table cellPadding="0" cellSpacing="0" width="100%">
                        <tbody>
                          <tr>
                            <td valign="top" width="56%">
                              <table
                                cellPadding="0"
                                cellSpacing="0"
                                width="100%"
                              >
                                <tbody>
                                  <tr>
                                    <td></td>
                                    <td
                                      style={{
                                        marginBottom: "10px",
                                        display: "block",
                                      }}
                                    >
                                      <span
                                        style={{
                                          fontSize: "22px",
                                          color: "#8FA9D4",
                                          fontWeight: 700,
                                        }}
                                      >
                                        <u>
                                          FLOOR PLAN:{" "}
                                          {propertyDetails?.projectName?.toUpperCase()}
                                          –{" "}
                                          {propertyDetails?.floorOffered?.toUpperCase()}
                                        </u>
                                      </span>
                                    </td>
                                  </tr>
                                  {hidePropertyFloorImage ? null : (
                                    <tr>
                                      <td
                                        width="61"
                                        valign="top"
                                        style={{ backgroundColor: "#021D77" }}
                                      ></td>
                                      <td>
                                        <table width="100%">
                                          <tbody>
                                            {/* <tr>
                                                          <td height="10"></td>
                                                        </tr> */}
                                            <tr>
                                              <td align="center" valign="top">
                                                <img
                                                  style={{
                                                    maxHeight: "500px",
                                                    objectFit: "contain",
                                                    width: "100%",
                                                    maxWidth: "550px",
                                                  }}
                                                  src={
                                                    encodeURI(propertyDetails?.propertyFloorImage)
                                                  }
                                                  alt="property_image"
                                                />
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </td>
                            {showFurnishingDetails ? (
                              <td width="44%" style={{ padding: "26px 20px 26px 10px" }}>
                                {!!furnishingDetails.length && <table width="100%">
                                  <tbody>
                                    <tr>
                                      <td>
                                        <span
                                          style={{
                                            fontSize: "22px",
                                            color: "#8FA9D4",
                                            fontWeight: 700,
                                          }}
                                        >
                                          FURNISHING DETAILS
                                        </span>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td height="10"></td>
                                    </tr>
                                    <tr>
                                      <td
                                        style={{
                                          padding: "20px",
                                          borderRadius: "12px",
                                          // background: `url(${require("../../../assets/images/proposal/box-shadow.png")})`,
                                          // backgroundPosition: "bottom 0 center",
                                          // backgroundSize: "200%",
                                          backgroundColor: "#F8F5FA",
                                          boxShadow:
                                            "0 3px 5px 0 rgba(0, 0, 0, 0.2), 0 10px 20px 0 rgba(0, 0, 0, 0.19)",
                                        }}
                                      >
                                        <table
                                          width="100%"
                                          cellPadding="0"
                                          cellSpacing="0"
                                        >
                                          <tbody>
                                            <tr>
                                              <td width="50%" valign="top">
                                                <ul
                                                  className="row"
                                                  style={{
                                                    listStyleType: "none",
                                                    padding: "0",
                                                    marginBottom: "0",
                                                    columns: "2",
                                                  }}
                                                >
                                                  {furnishingDetails.map(
                                                    (floor: {
                                                      attrName?: number;
                                                      attrOptionValue?: number;
                                                      name?: string;
                                                      value?: string;
                                                    }) => (
                                                      <li
                                                        className="col-md-6"
                                                        style={{
                                                          color: "#5E5E5E",
                                                          fontSize: "14px",
                                                          marginBottom: "5px",
                                                          lineHeight: "25px",
                                                        }}
                                                      >
                                                        <u
                                                          style={{
                                                            color: "#00134F",
                                                          }}
                                                        >
                                                          {floor?.attrName ||
                                                            floor?.name}
                                                          :{" "}
                                                        </u>
                                                        {floor?.attrOptionValue ||
                                                          floor?.value}
                                                      </li>
                                                    )
                                                  )}
                                                
                                                </ul>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                    <tr>
                                      <td height="24"></td>
                                    </tr>
                                    <tr>
                                      <td
                                        height="3"
                                        style={{ backgroundColor: "#C39864" }}
                                      ></td>
                                    </tr>
                                  </tbody>
                                </table>}
                              </td>
                            ) : (
                              ""
                            )}
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td height="30"></td>
                  </tr>
                </tbody>
              </table>
            )}
            {/* floor plan and furnishing details (left | right ) end   */}
          </>
        );
      }
    });
  }
};

export default RenderFloorPlanAndFurnishingDetails;
